// ---------------------------------------------- modules import
import M from "materialize-css";
import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useEffect
} from "react";

import { IUpdateThemeProps } from "./common";
import { ThemeContext } from "../../../contexts/themeContext";
import { themes } from "../../../store/helpers/themeHelper";

// ---------------------------------------------- the component
const UpdateTheme: FunctionComponent<IUpdateThemeProps> = ({
  profile,
  onChange,
  onUpdate
}) => {
  // ---------------------------------------------- handlers
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    onChange(e.currentTarget.name, e.currentTarget.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onUpdate(profile);
  };

  // ---------------------------------------------- effects
  useEffect(() => {
    const selects = document.querySelectorAll("select");

    M.FormSelect.init(selects);
  }, []);

  useEffect(() => {
    const modals = document.querySelectorAll(".modal");

    M.Modal.init(modals);
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <form className="card col s12 m8 offset-m2" onSubmit={handleSubmit}>
          <div className="card-content" style={{ paddingBottom: "0px" }}>
            <span style={{ fontSize: "0.75rem" }}>update</span>

            <span className="card-title" style={{ marginBottom: "20px" }}>
              MY THEME
            </span>

            <div className="input-field">
              <select
                name="themeIndex"
                defaultValue={profile.themeIndex}
                onChange={handleChange}
              >
                <option value={-1} disabled>
                  set theme
                </option>

                {themes.map(theme => (
                  <option key={theme.index} value={theme.index}>
                    {theme.name}
                  </option>
                ))}
              </select>

              <label>Theme</label>
            </div>
          </div>

          <div
            className="card-action row right-align"
            style={{ marginBottom: "0" }}
          >
            <button
              type="button"
              className={`btn-small waves-effect waves-light modal-trigger`}
              style={{ backgroundColor: theme.ui }}
              data-target="alert-theme"
            >
              Update
            </button>

            <div className="modal" id="alert-theme">
              <div className="modal-content center">
                <h5>Confirm Update</h5>

                <p>Are you sure you want to update your theme?</p>
              </div>

              <div className="modal-footer">
                <div className="container">
                  <button
                    type="submit"
                    className="btn modal-close"
                    style={{ backgroundColor: theme.ui }}
                  >
                    Yes, I'm sure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </ThemeContext.Consumer>
  );
};

export default UpdateTheme;
